import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const OfficesDeliverySchedule = () => import('./views/Index.vue');

export default [
  {
    path: '/offices-delivery-schedule',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin|marketing' },
    children: [
      {
        path: '',
        name: 'OfficesDeliverySchedule',
        component: OfficesDeliverySchedule,
        meta: { title: i18n.global.t('settings.officesDeliverySchedule') },
      },
    ],
  },
];
